<template>

  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        รายงานตารางรายการส่งเสริมการขายค่าเฉลี่ยค่าบริการและการเปลี่ยนแปลงอัตราค่าบริการในไตรมาส
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <router-link to="/Admin/Services_change">
            <i class="fa fa-dashboard"></i> รายงานตารางรายการส่งเสริมการขายค่าเฉลี่ยค่าบริการและการเปลี่ยนแปลงอัตราค่าบริการในไตรมาส
          </router-link>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12" style="height:660px;">
            <div class="box box-primary">
              <div class="box-header">
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form size="mini"
                             :label-position="label_position"
                             label-width="150px"
                             :model="form"
                             ref="ruleForm"
                             class="demo-ruleForm">
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item label="ประเภทผู้ให้บริการ">
                            <el-radio-group v-model="form.compare_type">
                              <el-radio :label="'group'">กลุ่มผู้ให้บริการ</el-radio>
                              <el-radio :label="'provider'">รายชื่อผู้ให้บริการ</el-radio>
                            </el-radio-group>
                          </el-form-item>
                          <el-form-item label="กลุ่มผู้ให้บริการ" required>
                            <el-radio-group v-model="form.provider_group"  :disabled="!(form.compare_type == 'group')">
                              <el-radio v-for="item in this.groupList" :key="item.id" :label="item.id" @change="radioPick(item.group_name_th, item.group_color_code)">{{ item.group_name_th}}</el-radio>
                            </el-radio-group>
                          </el-form-item>
                          <el-form-item label="รายชื่อผู้ให้บริการ" required>
                            <el-radio-group v-model="form.provider_list" :disabled="!(form.compare_type == 'provider')">
                              <el-radio v-for="item in this.providerList" :key="item.id" :label="item.id" @change="radioPick(item.brand_name, item.provider_color)">{{ item.brand_name}}</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="ประเภทรายงาน" v-if="form.type_report === ''">
                            <el-input disabled placeholder></el-input>
                          </el-form-item>
                          <el-form-item label="ไตรมาส" v-bind:class="[form.type_report === 'quarter' ?  '': 'not_display']" required>
                            <el-select v-model="form.quarter" ref="quarter" style="width:auto">
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>
                            &nbsp;
                            <el-date-picker v-model="form.year" type="year" :default-value="defaultDate" ref="year" ></el-date-picker>
                          </el-form-item>
                          <el-form-item label="แสดงอัตราที่ใช้กำกับดูแล"> 
                            <el-checkbox v-model="form.rate_addon" class="col-xs-12" v-for="(item, index) in this.regulates" :key="index" :label="item.id">
                              {{ item.service_name }}
                            </el-checkbox>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="ย่านความถี่">
                            <el-radio-group v-model="form.frequency">
                              <el-radio :label="900">900 MHz</el-radio>
                              <el-radio :label="1800">1800 MHz</el-radio>
                              <el-radio :label="2100">2.1 GHz</el-radio>
                              <el-radio :label="'other'">อื่นๆ</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item label="สถานะการให้บริการ">
                            <el-checkbox-group v-model="form.service_status">
                                <el-checkbox class="col-xs-12" label="S">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox>
                                <el-checkbox class="col-xs-12" label="U">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox>
                                <el-checkbox class="col-xs-12" label="CS">ประเภทองค์กร (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox>
                                <el-checkbox class="col-xs-12" label="CU">ประเภทองค์กร (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox>
                            </el-checkbox-group>
                          </el-form-item>
                        </div>
                      </div>
                    </el-form>
                    <div class="layout_filter_btn">
                      <button type="button" class="btn btn-primary" @click="generate()">ค้นหา</button>
                    </div>
                  </div>
                  <div class="box-body" v-if="displayTable">
                    <div class="col-sm-12" style="width:100%;text-align:right;padding-bottom:20px">
                      <div class="col-sm-12" style="text-align:right;">
                        <el-dropdown @command="exportFile">
                          <span class="btn btn-primary" >
                            Export<i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown" style="padding-right:2%">
                            <el-dropdown-item icon="el-icon-download" command="pdf">Export PDF</el-dropdown-item>
                            <el-dropdown-item icon="el-icon-download" command="doc">Export DOC</el-dropdown-item>
                            <el-dropdown-item icon="el-icon-download" command="xls">Export XLS</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                    </div>
                    <div id="data" ref="tableData">
                      <table class="tableG5" style="max-width: 1000px; margin-left: auto; margin-right: auto;">
                        <tr>
                          <td colspan="12" style="border:0px">
                            <label for="text_title">{{tabledata.text_title}}</label>
                          </td>
                        </tr>
                        <tr>
                          <td rowspan="2" style="width: 200px;" class="colorBox" v-bind:style="[style, style2]">{{ tabledata.provider_name }}</td>
                            <th colspan="2"
                              v-for="item in this.displayRegulate"
                              :key="item.id"
                              scope="colgroup"
                              rowspan="2"
                              style="max-width: 20%;"
                              class="colorBox"
                              v-bind:style="[style, style3]">{{ item.service_name }}
                            </th>
                          <th style="max-width: 10%;" class="colorBox" rowspan="2" v-bind:style="[style]">{{ tabledata.regulate.name }}</th>
                          <th style="max-width: 10%;" class="colorBox" rowspan="2" v-bind:style="[style]" v-if="reducer.length">{{reducer[0].service_name}}</th>
                          <th colspan="3" style="max-width: 50%;" scope="colgroup" class="colorBox" v-bind:style="style">{{ tabledata.quarter }}</th>
                          <td rowspan="4" style="max-width: 20%;" class="colorBox" v-bind:style="[style, style2]">การเปลี่ยนแปลงอัตราค่าบริการ</td>
                        </tr>
                        <tr>
                          <td scope="col" class="colorBox" v-bind:style="style">{{ tabledata.short_month[0] }}</td>
                          <td scope="col" class="colorBox" v-bind:style="style">{{ tabledata.short_month[1] }}</td>
                          <td scope="col" class="colorBox" v-bind:style="style">{{ tabledata.short_month[2] }}</td>
                        </tr>
                        <tr>
                          <td v-bind:colspan="(displayRegulate.length *2)+2+reducer.length" scope="colgroup" style="text-align:left">จำนวนรายการส่งเสริมการขาย (รายการ)</td>
                          <td scope="col" v-for="item in tabledata.amount" :key="item.index">{{ item > 0 ? item : '-' }}</td>
                        </tr>
                        <tr>
                          <td v-bind:colspan="(displayRegulate.length *2)+2+reducer.length" scope="colgroup" style="text-align:left">เป็นไปตามเงื่อนไขใบอนุญาต และมติที่ประชุม กทค.</td>
                          <td v-for="(check,index) in tabledata.checked" :key="index">{{ check }}</td>
                        </tr>
                        <tr>
                          <td rowspan="2" class="colorBox" v-bind:style="style">VOICE</br>(บาท/นาที)</td>
                          <td colspan="2" v-for="item in displayRegulate" :key="item.id" rowspan="2" v-bind:class="{regulate: item.status}">{{item.voice_service_rate.toFixed(2)}}</td>
                          <td rowspan="2" class="greenText"><b>{{ tabledata.regulate.Voice.toFixed(2) }}</b></td>
                          <td rowspan="2" v-if="reducer.length"><b>{{ reducer[0].voice_service_rate.toFixed(2) }}</b></td>
                          <td v-for="(item,index) in tabledata.avg.Voice" :key="index">{{ item > 0 ? item.toFixed(2) : '-' }}</td>
                          <td rowspan="2">{{ tabledata.status.Voice }}</td>
                        </tr>
                        <tr>
                          <td v-for="(item,index) in tabledata.percent.Voice" :key="index">
                            <p class="redText" v-if="item >= 0">{{ item ? '+'+item.toFixed(2)+'%' : '' }}</p>
                            <p class="greenText" v-else-if="item < 0">{{ item ? item.toFixed(2)+'%' : '' }}</p>
                            <p v-else></p>
                          </td>
                        </tr>
                        <tr>
                          <td rowspan="2" class="colorBox" v-bind:style="style">SMS</br>(บาท/ข้อความ)</td>
                          <td colspan="2" v-for="item in displayRegulate" :key="item.id" rowspan="2" v-bind:class="{regulate: item.status}">{{item.sms_service_rate.toFixed(2)}}</td>
                          <td rowspan="2" class="greenText"><b>{{ tabledata.regulate.SMS.toFixed(2) }}</b></td>
                          <td rowspan="2" v-if="reducer.length"><b>{{ reducer[0].sms_service_rate.toFixed(2) }}</b></td>
                          <td v-for="(item,index) in tabledata.avg.SMS" :key="index">{{ item > 0 ? item.toFixed(2) : '-' }}</td>
                          <td rowspan="2">{{ tabledata.status.SMS }}</td>
                        </tr>
                        <tr>
                          <td v-for="(item,index) in tabledata.percent.SMS" :key="index">
                            <p class="redText" v-if="item >= 0">{{ item ? '+'+item.toFixed(2)+'%' : '' }}</p>
                            <p class="greenText" v-else-if="item < 0">{{ item ? item.toFixed(2)+'%' : '' }}</p>
                            <p v-else></p>
                          </td>
                        </tr>
                        <tr>
                          <td rowspan="2" class="colorBox" v-bind:style="style">MMS</br>(บาท/ข้อความ)</td>
                          <td colspan="2" v-for="item in displayRegulate" :key="item.id" rowspan="2" v-bind:class="{regulate: item.status}">{{item.mms_service_rate.toFixed(2)}}</td>
                          <td rowspan="2" class="greenText"><b>{{ tabledata.regulate.MMS.toFixed(2) }}</b></td>
                          <td rowspan="2" v-if="reducer.length"><b>{{ reducer[0].mms_service_rate.toFixed(2) }}</b></td>
                          <td v-for="(item,index) in tabledata.avg.MMS" :key="index">{{ item > 0 ? item.toFixed(2) : '-' }}</td>
                          <td rowspan="2">{{ tabledata.status.MMS }}</td>
                        </tr>
                        <tr>
                          <td v-for="(item,index) in tabledata.percent.MMS" :key="index">
                            <p class="redText" v-if="item >= 0">{{ item ? '+'+item.toFixed(2)+'%' : '' }}</p>
                            <p class="greenText" v-else-if="item < 0">{{ item ? item.toFixed(2)+'%' : '' }}</p>
                            <p v-else></p>
                          </td>
                        </tr>
                        <tr>
                          <td rowspan="2" class="colorBox" v-bind:style="style">INTERNET</br>(บาท/MB)</td>
                          <td colspan="2" v-for="item in displayRegulate" :key="item.id" rowspan="2" v-bind:class="{regulate: item.status}">{{item.internet_service_rate.toFixed(2)}}</td>
                          <td rowspan="2" class="greenText"><b>{{ tabledata.regulate.Internet.toFixed(2) }}</b></td>
                          <td rowspan="2" v-if="reducer.length"><b>{{ reducer[0].internet_service_rate.toFixed(2) }}</b></td>
                          <td v-for="(item,index) in tabledata.avg.Internet" :key="index">{{ item > 0 ? item.toFixed(2) : '-' }}</td>
                          <td rowspan="2">{{ tabledata.status.Internet }}</td>
                        </tr>
                        <tr>
                          <td v-for="(item,index) in tabledata.percent.Internet" :key="index">
                            <p class="redText" v-if="item >= 0">{{ item ? '+'+item.toFixed(2)+'%' : '' }}</p>
                            <p class="greenText" v-else-if="item < 0">{{ item ? item.toFixed(2)+'%' : '' }}</p>
                            <p v-else></p>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div id="rawdata" style="display: none">
                      <table>
                        <tr>
                          <td colspan="12" style="border:0px">
                            <label for="text_title">{{tabledata.text_title}}</label>
                          </td>
                        </tr>
                        <tr>
                          <td rowspan="2" style="width: 200px;border: 1px solid black" class="colorBox" v-bind:style="[style, style2]">{{ tabledata.provider_name }}</td>
                            <th colspan="2"
                              v-for="item in this.displayRegulate"
                              :key="item.id"
                              scope="colgroup"
                              rowspan="2"
                              style="border: 1px solid black;width: 100px!important;"
                              class="colorBox"
                              v-bind:style="[style, style3]">{{ item.service_name }}
                            </th>
                          <th style="width: 100px!important;border: 1px solid black" class="colorBox" rowspan="2" v-bind:style="[style]">{{ tabledata.regulate.name }}</th>
                          <th style="width: 100px!important;border: 1px solid black" class="colorBox" rowspan="2" v-bind:style="[style]" v-if="reducer.length">{{reducer[0].service_name}}</th>
                          <th colspan="3" scope="colgroup" style="border: 1px solid black" class="colorBox" v-bind:style="style">{{ tabledata.quarter }}</th>
                          <td rowspan="4" style="border: 1px solid black;width: 200px;" class="colorBox" v-bind:style="[style, style2]">การเปลี่ยนแปลงอัตราค่าบริการ</td>
                        </tr>
                        <tr>
                          <td scope="col" style="border: 1px solid black" class="colorBox" v-bind:style="style">{{ tabledata.short_month[0] }}</td>
                          <td scope="col" style="border: 1px solid black" class="colorBox" v-bind:style="style">{{ tabledata.short_month[1] }}</td>
                          <td scope="col" style="border: 1px solid black" class="colorBox" v-bind:style="style">{{ tabledata.short_month[2] }}</td>
                        </tr>
                        <tr>
                          <td v-bind:colspan="(displayRegulate.length *2)+2+reducer.length" scope="colgroup" style="text-align:left;border: 1px solid black">จำนวนรายการส่งเสริมการขาย (รายการ)</td>
                          <td scope="col" style="border: 1px solid black" v-for="item in tabledata.amount" :key="item.index">{{ item > 0 ? item : '-' }}</td>
                        </tr>
                        <tr>
                          <td v-bind:colspan="(displayRegulate.length *2)+2+reducer.length" scope="colgroup" style="text-align:left;border: 1px solid black">เป็นไปตามเงื่อนไขใบอนุญาต และมติที่ประชุม กทค.</td>
                          <td style="border: 1px solid black" v-for="(check,index) in tabledata.checked" :key="index">{{ check }}</td>
                        </tr>
                        <tr>
                          <td rowspan="2" class="colorBox" v-bind:style="style" style="border: 1px solid black">VOICE</br>(บาท/นาที)</td>
                          <td colspan="2" v-for="item in displayRegulate" :key="item.id" rowspan="2" v-bind:class="{regulate: item.status}" style="border: 1px solid black">{{item.voice_service_rate.toFixed(2)}}</td>
                          <td rowspan="2" class="greenText" style="border: 1px solid black"><b>{{ tabledata.regulate.Voice.toFixed(2) }}</b></td>
                          <td rowspan="2" v-if="reducer.length"><b>{{ reducer[0].voice_service_rate.toFixed(2) }}</b></td>
                          <td v-for="(item,index) in tabledata.avg.Voice" :key="index" style="border: 1px solid black">{{ item > 0 ? item : '-' }}</td>
                          <td rowspan="2" style="border: 1px solid black">{{ tabledata.status.Voice }}</td>
                        </tr>
                        <tr>
                          <td v-for="(item,index) in tabledata.percent.Voice" :key="index" style="border: 1px solid black">
                            <p class="redText" v-if="item >= 0">{{ item ? '+'+item.toFixed(2)+'%' : '' }}</p>
                            <p class="greenText" v-else-if="item < 0">{{ item ? item.toFixed(2)+'%' : '' }}</p>
                            <p v-else></p>
                          </td>
                        </tr>
                        <tr>
                          <td rowspan="2" class="colorBox" v-bind:style="style" style="border: 1px solid black">SMS</br>(บาท/ข้อความ)</td>
                          <td colspan="2" v-for="item in displayRegulate" :key="item.id" rowspan="2" v-bind:class="{regulate: item.status}" style="border: 1px solid black">{{item.sms_service_rate.toFixed(2)}}</td>
                          <td rowspan="2" class="greenText" style="border: 1px solid black"><b>{{ tabledata.regulate.SMS.toFixed(2) }}</b></td>
                          <td rowspan="2" v-if="reducer.length" style="border: 1px solid black"><b>{{ reducer[0].sms_service_rate.toFixed(2) }}</b></td>
                          <td v-for="(item,index) in tabledata.avg.SMS" :key="index" style="border: 1px solid black">{{ item > 0 ? item : '-' }}</td>
                          <td rowspan="2" style="border: 1px solid black">{{ tabledata.status.SMS }}</td>
                        </tr>
                        <tr>
                          <td v-for="(item,index) in tabledata.percent.SMS" :key="index" style="border: 1px solid black">
                            <p class="redText" v-if="item >= 0">{{ item ? '+'+item.toFixed(2)+'%' : '' }}</p>
                            <p class="greenText" v-else-if="item < 0">{{ item ? item.toFixed(2)+'%' : '' }}</p>
                            <p v-else></p>
                          </td>
                        </tr>
                        <tr>
                          <td rowspan="2" class="colorBox" v-bind:style="style" style="border: 1px solid black">MMS</br>(บาท/ข้อความ)</td>
                          <td colspan="2" v-for="item in displayRegulate" :key="item.id" rowspan="2" v-bind:class="{regulate: item.status}" style="border: 1px solid black">{{item.mms_service_rate.toFixed(2)}}</td>
                          <td rowspan="2" class="greenText" style="border: 1px solid black"><b>{{ tabledata.regulate.MMS.toFixed(2) }}</b></td>
                          <td rowspan="2" v-if="reducer.length" style="border: 1px solid black"><b>{{ reducer[0].mms_service_rate.toFixed(2) }}</b></td>
                          <td v-for="(item,index) in tabledata.avg.MMS" :key="index" style="border: 1px solid black">{{ item > 0 ? item : '-' }}</td>
                          <td rowspan="2" style="border: 1px solid black">{{ tabledata.status.MMS }}</td>
                        </tr>
                        <tr>
                          <td v-for="(item,index) in tabledata.percent.MMS" :key="index" style="border: 1px solid black">
                            <p class="redText" v-if="item >= 0">{{ item ? '+'+item.toFixed(2)+'%' : '' }}</p>
                            <p class="greenText" v-else-if="item < 0">{{ item ? item.toFixed(2)+'%' : '' }}</p>
                            <p v-else></p>
                          </td>
                        </tr>
                        <tr>
                          <td rowspan="2" class="colorBox" v-bind:style="style" style="border: 1px solid black">INTERNET</br>(บาท/MB)</td>
                          <td colspan="2" v-for="item in displayRegulate" :key="item.id" rowspan="2" v-bind:class="{regulate: item.status}" style="border: 1px solid black">{{item.internet_service_rate.toFixed(2)}}</td>
                          <td rowspan="2" class="greenText" style="border: 1px solid black"><b>{{ tabledata.regulate.Internet.toFixed(2) }}</b></td>
                          <td rowspan="2" v-if="reducer.length" style="border: 1px solid black"><b>{{ reducer[0].internet_service_rate.toFixed(2) }}</b></td>
                          <td v-for="(item,index) in tabledata.avg.Internet" :key="index" style="border: 1px solid black">{{ item > 0 ? item : '-' }}</td>
                          <td rowspan="2" style="border: 1px solid black">{{ tabledata.status.Internet }}</td>
                        </tr>
                        <tr>
                          <td v-for="(item,index) in tabledata.percent.Internet" :key="index" style="border: 1px solid black">
                            <p class="redText" v-if="item >= 0">{{ item ? '+'+item.toFixed(2)+'%' : '' }}</p>
                            <p class="greenText" v-else-if="item < 0">{{ item ? item.toFixed(2)+'%' : '' }}</p>
                            <p v-else></p>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="box-body" v-else><h4 align="center">{{displayText}}</h4></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>

</template>
<script>
  const moment = require('moment')
  import Chart from 'chart.js'
  import { mapState, mapActions } from 'vuex'
  import jsPDF from 'jspdf'
  import { red } from 'bn.js'
  import utility from "../../lib/utility";
  export default {
    data() {
      return {
        defaultDate: '',
        dynamicDiv: [],
        mixedChart: [],
        label_position: 'top',
        controlBlog : [],
        tableName : null,
        month_th: ["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."],
        form: {
          compare_type: 'group',
          frequency: 2100,
          rate_addon: [],
          weighting: false,
          type_report: 'quarter',
          quarter: "",
          year: "",
          provider_group : null,
          provider_list : null,
          service_status : ['S','U','CS','CU']
        },
        provider_name : '',
        color: '',
        style: {
          backgroundColor : "#bceaa9"
        },
        style2: {
          width: '200px'
        },
        style3: {
          width: "100px !important"
        }
      }
    },
    beforeCreate() {
      this.$store.dispatch('Report_G6/serviceRegulate')
      this.$store.dispatch('Report_G6/getGroupList')
      this.$store.dispatch('Report_G6/getOperatorList')
    },
   computed: {
   ...mapState({
      groupList : store => store.Report_G6.groupList,
      providerList : store => store.Report_G6.providerList,
      regulates : store => store.Report_G6.regulates,
      quarterdata : store => store.Report_G6.quarterdata,
      ratechange : store => store.Report_G6.rate_change,
      conditions : store => store.Report_G6.conditions,
      tabledata : store => store.Report_G6.table_data,
      displayTable : store => store.Report_G6.display_status,
      displayText : store => store.Report_G6.display_text,
      displayRegulate : store => store.Report_G6.display_regulate,
      reducer : store => store.Report_G6.reducer
    })
   },
    methods: {
      ...mapActions({
        quarterReport : 'Report_G6/quarterReport'
      }),
      generate() {
        if (this.form.compare_type == 'group' && !this.form.provider_group) {
          this.$alert('กรุณาเลือกกลุ่มผู้ให้บริการ', 'แจ้งเตือน', {
            confirmButtonText: 'ตกลง',
            callback: action => {}
          })
          return false
        }
        if (this.form.compare_type == 'provider'  && !this.form.provider_list) {
          this.$alert('กรุณาเลือกรายชื่อผู้ให้บริการ', 'แจ้งเตือน', {
            confirmButtonText: 'ตกลง',
            callback: action => {}
          })
          return false
        }
        if (!this.form.quarter || !this.form.year) {
          this.$alert('กรุณาเลือกไตรมาสและปีที่ต้องการค้นหา.', 'แจ้งเตือน', {
            confirmButtonText: 'ตกลง',
            callback: action => {
              if (!this.form.quarter) {
                this.$refs.quarter.focus()
              }else {
                this.$refs.year.focus()
              }
            }
          })
          return false
        }
        let pool = this.form.compare_type == 'group' ? this.groupList : this.providerList
        this.form.list = this.form.compare_type == 'group' ? pool.filter(item => item.id == this.form.provider_group) : pool.filter(item => item.id == this.form.provider_list)
        this.style.backgroundColor = this.color
        this.tableName = this.radioName
        this.quarterReport(this.form)
      },
      radioPick(name, color){
        this.radioName = name,
        this.color = color
      },
      exportFile(com){
        if(com=="pdf"){
          var doc = new jsPDF("landscape");
          doc.internal.scaleFactor = 10;
          this.$html2canvas(this.$refs.tableData, { canvas: null})
            .then(function(canvas){
              const img = canvas.toDataURL("image/png", 1.0);
              doc.addImage(img, "JPEG", 0, 0,300,300*(canvas.height/canvas.width));
              doc.save("Report.pdf");
          });
        }else if(com=="doc"){
          var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' "+
                        "xmlns:w='urn:schemas-microsoft-com:office:word' "+
                        "xmlns='http://www.w3.org/TR/REC-html40'>"+
                        "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
          var footer = "</body></html>";
          let clone = document.getElementById("data").cloneNode(true);
          clone.children[0].style.maxWidth = 'none';
          var sourceHTML = header+clone.innerHTML+footer;
          var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
          var fileDownload = document.createElement("a");
          document.body.appendChild(fileDownload);
          fileDownload.href = source;
          fileDownload.download = 'Report.doc';
          fileDownload.click();
          document.body.removeChild(fileDownload);
        }else if(com=="xls"){
          var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' "+
                        "xmlns:w='urn:schemas-microsoft-com:office:word' "+
                        "xmlns='http://www.w3.org/TR/REC-html40'>"+
                        "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
          var footer = "</body></html>";
          var sourceHTML = header+document.getElementById("rawdata").innerHTML+footer;
          var source = 'data:application/vnd.ms-excel;charset=utf-8,' + encodeURIComponent(sourceHTML);
          var fileDownload = document.createElement("a");
          document.body.appendChild(fileDownload);
          fileDownload.href = source;
          fileDownload.download = 'Nbtc_report_m6.xls';
          fileDownload.click();
          document.body.removeChild(fileDownload);
        }
      },
    }
  }

</script>
<style>
  .bordered {
    border: 1px solid black
  }
  table tr td th {
    border: 1px solid black
  }
  .colorBox {
    background-color: #bceaa9;
  }
  .tableG5 td,
  .tableG5 th {
    padding: 5px;
    border: 1px solid black;
  }
  .redText {
    color: red;
  }
  .greenText{
    color : green;
  }
  .custom {
    width: 100%;
    margin-top: 30px;
    font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
    border-collapse: collapse;
  }

  .custom td,
  .custom th {
    padding: 8px;
    border: 1px solid #ddd;
  }

  .custom th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
  }

  .regulate{
    font-size: 14px;
    font-weight: bold;
    color : green;
  }

</style>